/**
 * Organizations reach the client from two sources: the GraphQL `me` query, which
 * exposes the `id` virtual, and the Shopify SSO REST exchange, which serialises
 * raw Mongo documents and therefore only carries `_id`. Any lookup that checks
 * one and not the other silently misses for a whole session.
 *
 * Lives outside `authStore` so consumers can still resolve an org key in tests
 * that mock the store module wholesale.
 */
export const orgKey = (org: any): string | null => {
    const raw = org?.id ?? org?._id;
    return raw ? String(raw) : null;
};
